import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { REPORT_TYPES } from "../../../pages/reports/constants";

export const MULTIPLE_CLIENT_REPORT_REDUCER_NAME = "mc-report";

const initialState = {
  page: 0,
  size: 20,
  totalCount: 0,
  reports: [],
  filters: {
    periodFrom: "",
    periodTo: "",
    clientStatus: "",
    changedLevelRisk: "",
    typeOfRule: "",
    ruleName: "",
    caseStatus: "",
    resolutionStatus: "",
    riskLevel: "",
    forExport: false,
    type: REPORT_TYPES.MULTI,
  },
  enabled: false,
};

const multipleClientReportSlice = createSlice({
  name: MULTIPLE_CLIENT_REPORT_REDUCER_NAME,
  initialState,
  reducers: {
    setPageMultipleClientReport: (state, { payload }) => {
      state.page = parseInt(payload, 10);
    },
    setSizeMultipleClientReport: (state, { payload }) => {
      state.size = parseInt(payload, 10);
    },
    setTotalCountMultipleClientReport: (state, { payload }) => {
      state.totalCount = parseInt(payload, 10);
    },
    setReportsMultipleClientReport: (state, { payload }) => {
      state.reports = [...payload];
    },
    setFiltersMultipleClientReport: (state, { payload }) => {
      state.filters = { ...state.filters, ...payload };
    },
    setEnabledQueryMultipleClientReport: (state, { payload }) => {
      state.enabled = payload;
    },
    clearMultipleClientReports: (state) => {
      state.page = initialState.page;
      state.size = initialState.size;
      state.totalCount = initialState.totalCount;
      state.filters = { ...initialState.filters };
      state.reports = initialState.reports;
      state.enabled = initialState.enabled;
    },
  },
});

export default multipleClientReportSlice.reducer;

export const {
  setPageMultipleClientReport,
  setSizeMultipleClientReport,
  setTotalCountMultipleClientReport,
  setReportsMultipleClientReport,
  setFiltersMultipleClientReport,
  setEnabledQueryMultipleClientReport,
  clearMultipleClientReports,
} = multipleClientReportSlice.actions;

export const useSelectFiltersMultipleClientReport = () =>
  useSelector((state) => state[MULTIPLE_CLIENT_REPORT_REDUCER_NAME].filters);

export const useSelectPageMultipleClientReport = () =>
  useSelector((state) => state[MULTIPLE_CLIENT_REPORT_REDUCER_NAME].page);

export const useSelectSizeMultipleClientReport = () =>
  useSelector((state) => state[MULTIPLE_CLIENT_REPORT_REDUCER_NAME].size);

export const useSelectTotalCountMultipleClientReport = () =>
  useSelector((state) => state[MULTIPLE_CLIENT_REPORT_REDUCER_NAME].totalCount);

export const useSelectReportsMultipleClientReport = () =>
  useSelector((state) => state[MULTIPLE_CLIENT_REPORT_REDUCER_NAME].reports);

export const useSelectEnabledMultipleClientReport = () =>
  useSelector((state) => state[MULTIPLE_CLIENT_REPORT_REDUCER_NAME].enabled);
